import React from 'react'

const Unsuccessfull = (payment) => {
  return (
    <div className='page'>
      <div className="card-title">Failed to Process Payment Method</div>
      <p className="details">
        We weren’t able to charge the payment method for your company billing account, resulting in an overdue balance of ${(payment.amount/100).toFixed(2)}.<br/><br/>Use the billing page to update payment details or retry collection from Stripe Billing Portal.
      </p>
      <hr style={{marginBottom: '20px'}}/>
    </div>
  )
}

export default Unsuccessfull
